import { useCallback } from 'react';
import { FormShowTemplate } from 'framework/form';
import { ShowSection } from 'framework/ui/layout';
import { useProjectId } from 'domain/shared/project';
import { useDocumentStorageContext } from 'framework/documentStorage';
import AcceptanceArtifactsList from './AcceptanceArtifactsList';
import { EditableListFormShowTemplate } from 'framework/list';

const DEFAULT_LOADING_PARAMS = { pageSize: 100, pageNumber: 1 };

const AcceptanceArtifactsContext = () => {
  const projectId = useProjectId();
  const { searchDocuments } = useDocumentStorageContext();

  const loadDocuments = useCallback(async () => {
    const response = await searchDocuments({
      ...DEFAULT_LOADING_PARAMS,
      filter: { projectId: { eq: projectId } },
    });
    const result = response?.result ?? [];
    const items = result.map((item, i) => ({ ...item, index: i + 1 }));
    return { documentsData: items };
  }, [projectId, searchDocuments]);

  return (
    <ShowSection sx={{ '&.section-details__wrapper': { p: '0px !important' }, mt: '12px !important' }}>
      <FormShowTemplate
        isInitialsLoadingPosition
        submitFormFunc={loadDocuments}
        afterSubmit={{
          message: 'You are awesome! The Project has been successfully updated.',
        }}
        getDataFunc={loadDocuments}
      >
        <EditableListFormShowTemplate listSource="documentsData">
          <AcceptanceArtifactsList />
        </EditableListFormShowTemplate>
      </FormShowTemplate>
    </ShowSection>
  );
};

export default AcceptanceArtifactsContext;
